import { configureStore, combineReducers } from "@reduxjs/toolkit"
import { persistStore, persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import { CookieStorage } from "redux-persist-cookie-storage"
import Cookies from "cookies-js"
import layoutReducer from "./layout"
import organizationReducer from "./organization"
import authReducer from "./auth"

const cookieStorage = new CookieStorage(Cookies, {
  expiration: {
    default: 30 * 24 * 60 * 60, // 30 days
  },
})

// Organization persist config (localStorage)
const organizationPersistConfig = {
  key: "organization",
  storage,
  whitelist: ["organizations", "activeOrganization"],
}

// Auth persist config (cookies)
const authPersistConfig = {
  key: "auth",
  storage: cookieStorage,
  whitelist: ["token", "user"],
}

const rootReducer = combineReducers({
  layout: layoutReducer,
  organization: persistReducer(organizationPersistConfig, organizationReducer),
  auth: persistReducer(authPersistConfig, authReducer),
})

export const makeStore = () => {
  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
        },
      }),
  })

  return store
}

export const store = makeStore()
export const persistor = persistStore(store)

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore["getState"]>
export type AppDispatch = AppStore["dispatch"]
